import { createAction } from "@reduxjs/toolkit";

export const commonBeforeUnload = createAction("COMMON:BEFORE_UNLOAD");
